module.exports = __webpack_public_path__ + "fonts/arlaif_bd-webfont.fa965442.ttf";